<template>
    <div>
        <vue-typeahead-bootstrap
            v-model="query"
            :data="clientAssets"
            :serializer="item => item.name"
            :screen-reader-text-serializer="item => `Client asset: ${item.name}`"
            :placeholder="placeholder"
            @hit="onSelect"
        >
            <template slot="suggestion" slot-scope="{ data, htmlText }">
                <div class="d-flex align-items-center">
                    <img
                        class=""
                        :src="data.img"
                        style="width: 20px; height: 20px;" />

                    <!-- Note: the v-html binding is used, as htmlText contains
                         the suggestion text highlighted with <strong> tags -->
                    <span class="ml-4" v-html="htmlText"></span>
                </div>
            </template>
        </vue-typeahead-bootstrap>
    </div>
</template>

<script>
export default {
    name: "client-asset-autocomplete",
    props: {
      clientAssets: {
          type: Array,
          default () {
              return [
                  {
                      id: 1,
                      name: 'Canada',
                      route: 'https://google.com?q=Canada'
                  },
                  {
                      id: 2,
                      name: 'United States',
                      route: 'https://google.com?q=United+States'
                  },
                  {
                      id: 3,
                      name: 'Mexico',
                      route: 'https://google.com?q=Mexico'
                  },
              ]
          }
      },
        placeholder: {
          type: String,
            default: `Begin typing...`
        }
    },

    methods: {
      onSelect($event){
        // console.log($event)
          if($event.hasOwnProperty('route')){
              window.location = $event.route
          }
      }
    },
    data: () => ({
        loading: false,
        query: null
    }),
}
</script>
